import { cn } from '@/lib/cn';

export type StatTileProps = {
  label: string;
  value: string;
  subtext?: string;
  accent: 'accent' | 'warning' | 'danger';
  progressPct: number;
};

function clampPct(n: number): number {
  if (Number.isNaN(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

export function StatTile({ label, value, subtext, accent, progressPct }: StatTileProps) {
  const accentClasses = {
    accent: { bar: 'bg-accent', text: 'text-accent' },
    warning: { bar: 'bg-warning', text: 'text-warning' },
    danger: { bar: 'bg-danger', text: 'text-danger' },
  } as const;
  const tone = accentClasses[accent];
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border bg-surface p-7">
      <p className="text-label uppercase tracking-[0.08em] text-text-secondary">
        {label}
      </p>
      <div className="flex items-baseline gap-2">
        <span
          className={cn('font-display font-bold', tone.text)}
          style={{ fontSize: '36px', lineHeight: 1.1, letterSpacing: '-0.02em' }}
        >
          {value}
        </span>
        {subtext ? (
          <span className="text-[13px] font-medium text-text-secondary">
            {subtext}
          </span>
        ) : null}
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-surface-tint">
        <div
          className={cn('h-full transition-all', tone.bar)}
          style={{ width: `${clampPct(progressPct)}%` }}
        />
      </div>
    </div>
  );
}
